import { IRequirement, IRobotOption } from '../models/robot-selector.model';
import { isEligible, ratedPayloadKg } from './eligibility';

export interface IClosestAlternative {
    robot: IRobotOption;
    payloadShortfallKg: number;
    reachShortfallMm: number;
}

const MAX_ALTERNATIVES = 2;

export function closestAlternatives(
    robots: readonly IRobotOption[],
    requirement: IRequirement,
): IClosestAlternative[] {
    if (robots.some((robot) => isEligible(robot, requirement))) {
        return [];
    }

    return robots
        .map((robot) => ({
            robot,
            payloadShortfallKg: Math.max(0, requirement.payloadKg - ratedPayloadKg(robot)),
            reachShortfallMm: Math.max(0, requirement.reachMm - robot.reachMm),
        }))
        .sort((left, right) => {
            const byShortfall = relativeShortfall(left, requirement) - relativeShortfall(right, requirement);
            if (byShortfall !== 0) {
                return byShortfall;
            }

            return left.robot.id.localeCompare(right.robot.id);
        })
        .slice(0, MAX_ALTERNATIVES);
}

function relativeShortfall(alternative: IClosestAlternative, requirement: IRequirement): number {
    return (
        alternative.payloadShortfallKg / requirement.payloadKg + alternative.reachShortfallMm / requirement.reachMm
    );
}
